__webpack_require__.p = "/stablo-template/";